const bloodGroups = [
  { label: "A+", value: "A_POSITIVE" },
  { label: "A−", value: "A_NEGATIVE" },
  { label: "B+", value: "B_POSITIVE" },
  { label: "B−", value: "B_NEGATIVE" },
  { label: "AB+", value: "AB_POSITIVE" },
  { label: "AB−", value: "AB_NEGATIVE" },
  { label: "O+", value: "O_POSITIVE" },
  { label: "O−", value: "O_NEGATIVE" },
];

const doctorSpecialization = [
  "Cardiology",
  "Dermatology",
  "Neurology",
  "Orthopedics",
  "Pediatrics",
  "Oncology",
  "Psychiatry",
  "Ophthalmology",
  "Gynecology",
  "ENT (Ear, Nose, Throat)",
  "General Medicine",
  "Urology",
  "Anesthesiology",
  "Radiology",
  "Pathology",
];
const doctorDepartments = [
  "Cardiology Department",
  "Neurology Department",
  "Orthopedics Department",
  "Pediatrics Department",
  "Oncology Department",
  "Dermatology Department",
  "Emergency Department",
  "Radiology Department",
  "ENT Department",
  "General Medicine Department",
  "Urology Department",
  "Gynecology Department",
  "Anesthesiology Department",
  "Pathology Department",
];

const appointmentReasons = [
  "General Checkup",
  "Follow-up Visit",
  "New Symptoms Consultation",
  "Lab Test Review",
  "Prescription Refill",
  "Vaccination",
  "Chronic Disease Management",
  "Post-Surgery Follow-up",
  "Injury or Wound Care",
  "Mental Health Consultation",
  "Pregnancy Checkup",
  "Pediatric Consultation",
  "Allergy Testing",
  "Skin Problem Consultation",
  "Eye Examination",
  "Hearing Problem Consultation",
  "Blood Pressure Check",
  "Diabetes Management",
  "Pain Management",
  "Diet and Nutrition Counseling",
];

const symptoms = [
  "Fever",
  "Chills",
  "Fatigue",
  "Weakness",
  "Body Pain",
  "Weight Loss",
  "Weight Gain",
  "Night Sweats",
  "Loss of Appetite",
  "Dehydration",
  "Cough",
  "Dry Cough",
  "Productive Cough",
  "Sore Throat",
  "Runny Nose",
  "Nasal Congestion",
  "Sneezing",
  "Shortness of Breath",
  "Chest Pain",
  "Wheezing",
  "Difficulty Breathing",
  "Palpitations",
  "Chest Tightness",
  "Irregular Heartbeat",
  "Swelling of Feet",
  "Fainting",
  "Nausea",
  "Vomiting",
  "Abdominal Pain",
  "Diarrhea",
  "Constipation",
  "Bloating",
  "Heartburn",
  "Indigestion",
  "Loss of Taste",
  "Blood in Stool",
  "Headache",
  "Migraine",
  "Dizziness",
  "Confusion",
  "Blurred Vision",
  "Numbness",
  "Tingling Sensation",
  "Seizures",
  "Memory Loss",
  "Difficulty Concentrating",
  "Joint Pain",
  "Muscle Pain",
  "Back Pain",
  "Neck Pain",
  "Stiffness",
  "Swelling in Joints",
  "Limited Range of Motion",
  "Rash",
  "Itching",
  "Redness",
  "Dry Skin",
  "Peeling Skin",
  "Swelling",
  "Acne",
  "Bruising",
  "Hives",
  "Burning Urination",
  "Blood in Urine",
  "Pelvic Pain",
  "Lower Back Pain",
  "Ear Pain",
  "Hearing Loss",
  "Tinnitus (Ringing in Ears)",
  "Loss of Smell",
  "Sinus Pressure",
  "Excessive Thirst",
  "Frequent Urination",
  "Sweating",
  "Cold Intolerance",
  "Heat Intolerance",
  "Anxiety",
  "Depression",
  "Insomnia",
  "Mood Swings",
  "Irritability",
  "Menstrual Cramps",
  "Irregular Periods",
  "Vaginal Discharge",
  "Erectile Dysfunction",
  "Pain",
  "General Discomfort",
];

const tests = [
  "Complete Blood Count (CBC)",
  "Blood Sugar (Fasting)",
  "Blood Sugar (Postprandial)",
  "HbA1c (Glycated Hemoglobin)",
  "Lipid Profile",
  "Liver Function Test (LFT)",
  "Kidney Function Test (KFT)",
  "Thyroid Profile (T3, T4, TSH)",
  "Electrolyte Panel (Na, K, Cl)",
  "Calcium Test",
  "Vitamin D Test",
  "Vitamin B12 Test",
  "Iron Studies",
  "Coagulation Profile (PT, INR, aPTT)",
  "CRP (C-Reactive Protein)",
  "ESR (Erythrocyte Sedimentation Rate)",
  "D-Dimer Test",
  "Blood Culture and Sensitivity",
  "Serum Ferritin",
  "Uric Acid Test",
  "Urine Routine and Microscopy",
  "Urine Culture",
  "Urine Pregnancy Test (UPT)",
  "Stool Routine and Microscopy",
  "Stool Occult Blood Test",
  "Stool Culture",
  "Widal Test (Typhoid)",
  "Dengue NS1 Antigen",
  "Dengue IgG/IgM Antibody",
  "Malaria Parasite Smear",
  "HIV I & II Test",
  "Hepatitis B Surface Antigen (HBsAg)",
  "Hepatitis C Antibody Test",
  "COVID-19 RTPCR",
  "COVID-19 Antibody Test",
  "Tuberculosis (Mantoux Test)",
  "Rheumatoid Factor (RF)",
  "ANA (Antinuclear Antibody)",
  "VDRL (Syphilis Test)",
  "X-Ray Chest PA View",
  "X-Ray Abdomen",
  "CT Scan Brain",
  "CT Scan Abdomen",
  "MRI Brain",
  "MRI Spine",
  "Ultrasound Abdomen and Pelvis",
  "Ultrasound Thyroid",
  "Echocardiography (2D Echo)",
  "Electrocardiogram (ECG)",
  "EEG (Electroencephalogram)",
  "Mammography",
  "Bone Densitometry (DEXA Scan)",
  "Pulmonary Function Test (PFT)",
  "Audiometry (Hearing Test)",
  "Vision Test (Eye Refraction)",
  "Pap Smear",
  "PSA (Prostate Specific Antigen)",
  "Hormone Profile (FSH, LH, Prolactin, Testosterone)",
  "Beta-hCG Quantitative Test",
  "Allergy Panel Test",
  "Glucose Tolerance Test (GTT)",
  "Lactate Dehydrogenase (LDH)",
  "Karyotyping",
  "PCR (Polymerase Chain Reaction)",
  "Microarray Test",
  "BRCA Gene Test (Breast Cancer)",
  "NIPT (Prenatal Screening)",
  "HLA Typing",
];

const medicineFrequencies = [
  { label: "1-0-1 (Morning & Night)", value: "1-0-1" },
  { label: "1-1-1 (Morning, Afternoon & Night)", value: "1-1-1" },
  { label: "1-0-0 (Morning Only)", value: "1-0-0" },
  { label: "0-0-1 (Night Only)", value: "0-0-1" },
  { label: "0-1-0 (Afternoon Only)", value: "0-1-0" },
  { label: "1-1-0 (Morning & Afternoon)", value: "1-1-0" },
  { label: "0-1-1 (Afternoon & Night)", value: "0-1-1" },
  { label: "2-0-2 (2 Tabs Morning & Night)", value: "2-0-2" },
  { label: "2-1-2 (2 Morning, 1 Afternoon, 2 Night)", value: "2-1-2" },
  { label: "1-2-1 (1 Morning, 2 Afternoon, 1 Night)", value: "1-2-1" },
  { label: "1-0-2 (1 Morning, 2 Night)", value: "1-0-2" },
  { label: "1-1-1 (After Meals)", value: "1-1-1 (After Meals)" },
  { label: "1-0-1 (Before Meals)", value: "1-0-1 (Before Meals)" },
  { label: "Once Daily", value: "Once Daily" },
  { label: "Twice Daily", value: "Twice Daily" },
  { label: "Thrice Daily", value: "Thrice Daily" },
  { label: "Every 6 Hours", value: "Every 6 Hours" },
  { label: "Every 8 Hours", value: "Every 8 Hours" },
  { label: "Every 12 Hours", value: "Every 12 Hours" },
  { label: "Every 24 Hours", value: "Every 24 Hours" },
  { label: "Alternate Days", value: "Alternate Days" },
  { label: "Weekly Once", value: "Weekly Once" },
  { label: "SOS (As Needed)", value: "SOS (As Needed)" },
  { label: "Before Breakfast", value: "Before Breakfast" },
  { label: "After Breakfast", value: "After Breakfast" },
  { label: "Before Lunch", value: "Before Lunch" },
  { label: "After Lunch", value: "After Lunch" },
  { label: "Before Dinner", value: "Before Dinner" },
  { label: "After Dinner", value: "After Dinner" },
  { label: "Before Sleep", value: "Before Sleep" },
];

const frequencyMap: Record<string, number> = {
  "1-0-0": 1,
  "0-1-0": 1,
  "0-0-1": 1,
  "1-0-1": 2,
  "1-1-0": 2,
  "0-1-1": 2,
  "1-1-1": 3,
  "2-0-2": 4,
  "2-1-2": 5,
  "1-2-1": 4,
  "1-0-2": 3,
  "1-1-1 (After Meals)": 3,
  "1-0-1 (Before Meals)": 2,
  "Once Daily": 1,
  "Twice Daily": 2,
  "Thrice Daily": 3,
  "Every 6 Hours": 4,
  "Every 8 Hours": 3,
  "Every 12 Hours": 2,
  "Every 24 Hours": 1,
  "Alternate Days": 0.5,
  "Weekly Once": 1 / 7,  
  "SOS (As Needed)": 0,
  "Before Breakfast": 1,
  "After Breakfast": 1,
  "Before Lunch": 1,
  "After Lunch": 1,
  "Before Dinner": 1,
  "After Dinner": 1,
  "Before Sleep": 1,
};


const medicineRoutes = [
  { label: "Oral (By Mouth)", value: "Oral" },
  { label: "Sublingual (Under the Tongue)", value: "Sublingual" },
  { label: "Buccal (Inside the Cheek)", value: "Buccal" },
  { label: "Topical (On the Skin)", value: "Topical" },
  { label: "Transdermal (Through the Skin Patch)", value: "Transdermal" },
  { label: "Inhalation (Through Mouth or Nose)", value: "Inhalation" },
  { label: "Nasal (Through the Nose)", value: "Nasal" },
  { label: "Ophthalmic (Eye Drops/Ointment)", value: "Ophthalmic" },
  { label: "Otic (Ear Drops)", value: "Otic" },
  { label: "Intravenous (IV – Into a Vein)", value: "Intravenous" },
  { label: "Intramuscular (IM – Into a Muscle)", value: "Intramuscular" },
  { label: "Subcutaneous (Under the Skin)", value: "Subcutaneous" },
  { label: "Intrathecal (Into the Spinal Canal)", value: "Intrathecal" },
  { label: "Rectal (Via the Rectum)", value: "Rectal" },
  { label: "Vaginal (Via the Vagina)", value: "Vaginal" },
  { label: "Intradermal (Into the Skin Layer)", value: "Intradermal" },
  { label: "Intraocular (Into the Eye)", value: "Intraocular" },
  { label: "Intraarticular (Into a Joint)", value: "Intraarticular" },
  {
    label: "Intraperitoneal (Into the Abdominal Cavity)",
    value: "Intraperitoneal",
  },
  {
    label: "Inhalation (Nebulizer or Inhaler)",
    value: "Inhalation (Nebulizer or Inhaler)",
  },
  { label: "Sublingual Spray", value: "Sublingual Spray" },
  { label: "Mouth Rinse (Oral Rinse)", value: "Mouth Rinse" },
  { label: "Suppository (Rectal/Vaginal Form)", value: "Suppository" },
  { label: "Implant (Under the Skin Device)", value: "Implant" },
  { label: "Infusion (Slow Continuous IV)", value: "Infusion" },
];

const medicineTypes = [
  { value: "TABLET", label: "Tablet" },
  { value: "CAPSULE", label: "Capsule" },
  { value: "SYRUP", label: "Syrup" },
  { value: "INJECTION", label: "Injection" },
  { value: "CREAM", label: "Cream" },
  { value: "OINTMENT", label: "Ointment" },
  { value: "DROPS", label: "Drops" },
  { value: "INHALER", label: "Inhaler" },
  { value: "OTHER", label: "Other" }
];


const medicineCategories = [
  { value: "ANALGESIC", label: "Analgesic" },
  { value: "ANTIBIOTIC", label: "Antibiotic" },
  { value: "ANTIVIRAL", label: "Antiviral" },
  { value: "ANTIHISTAMINE", label: "Antihistamine" },
  { value: "ANTIDIABETIC", label: "Antidiabetic" },
  { value: "CARDIOVASCULAR", label: "Cardiovascular" },
  { value: "RESPIRATORY", label: "Respiratory" },
  { value: "VITAMIN_SUPPLEMENT", label: "Vitamin Supplement" },
  { value: "OTHER", label: "Other" },
];

export {
  medicineTypes,
  medicineRoutes,
  medicineFrequencies,
  tests,
  bloodGroups,
  doctorSpecialization,
  doctorDepartments,
  appointmentReasons,
  symptoms,
  medicineCategories,
  frequencyMap
};
